angular.module('unergie.main')
.directive('cases', ($rootScope, BoFeaturesService, AlertManager, AccountService, ApiUser, DataAccess, ErrorCatcher) =>
    ({
        restrict: 'E',
        templateUrl: '/directives/cases/cases.html',
        scope: {
            contract: '=',
            idCase: '=',
            showTitle: '=',
        },
        link($scope) {
            $scope.cases = null
            $scope.accessSge = BoFeaturesService.isFeatureOn('accessSge')
            $scope.canAddCase = BoFeaturesService.isFeatureOn('canAddCase') && $scope.contract
            $scope.loadingCase = false

            $scope.idCaseField = {
                new_id_case: {
                    label: `Id de l'Affaire`,
                    type: 'text',
                },
            }
            $scope.newIdCase = { new_id_case: '' }

            $scope.refreshPrmTemplate = {
                expl: {
                    label: `Pour rappel ce bouton ne rafraîchit que le statut de l'affaire et non celui du contrat`,
                    type: 'label',
                },
            }

            $scope.getStatusCodeColorClass = (status_code, last_milestone_code, reject_code) => {
                if (last_milestone_code === 'CPNR' || reject_code) {
                    return 'darkish-pink'
                }
                return _.defaultTo({ COURS: 'orange', TERMN: 'dark-green', ANNUL: 'bluegrey' }[status_code], 'bluegrey')
            }

            $scope.getStatusCodeBorderLeftColorClass = (status_code, last_milestone_code, reject_code) => `border-left-${$scope.getStatusCodeColorClass(status_code, last_milestone_code, reject_code)}`

            const refresh = function () {
                $scope.loadingCase = true
                return Promise.resolve().then(() => {
                    if ($scope.contract) {
                        return DataAccess.cases({ id_account: $scope.contract.id_account, id_contract: $scope.contract.id }).$promise
                    }
                    return DataAccess.casesElecSearch({ id: $scope.idCase, withRelated: 'interventions,milestones' }).$promise
                })
                .then((contractCases) => {
                    $scope.cases = contractCases
                    if ($scope.contract) {
                        $scope.contract.cases = contractCases
                        $scope.contract.pendingContractAmendment = _.some($scope.contract.cases, (c) => c.status_code === 'COURS' && ['CST', 'F180'].includes(c.object_code))
                    }
                })
                .catch(ErrorCatcher)
                .finally($scope.loadingCase = false)
            }

            $scope.canCancelCase = (c) => c && ['COURS'].includes(c.status_code) && (c.cancel_status === null) && c.id_grd_contract && BoFeaturesService.isFeatureOn('canCancelCase')

            $scope.cancelCase = function (c) {
                $scope.cancellingCase = true
                return ApiUser.cancelCase({ idCase: c.id }, {}).$promise
                .then((result) => { AlertManager.success(`Annulation demandée : ${result.message}`, 6000) })
                .catch(ErrorCatcher)
                .finally(() => {
                    refresh()
                    $scope.cancellingCase = false
                })
            }

            $scope.canRefreshCase = () => BoFeaturesService.isFeatureOn('canRefreshCase')

            $scope.addCase = () => {
                $scope.addingCase = true
                return ApiUser.addCase({ idCase: $scope.newIdCase.new_id_case, idContract: $scope.contract.id }, {}).$promise
                .then((result) => { AlertManager.success(`Affaire ajoutée : ${$scope.newIdCase.new_id_case}`, 6000) })
                .catch(ErrorCatcher)
                .finally(() => {
                    refresh()
                    $scope.addingCase = false
                })
            }

            $scope.refreshCase = function (c) {
                c.loadingCase = true
                return ApiUser.refreshCase({ idCase: c.id }, {}).$promise
                .then(() => AlertManager.success(`Affaire ${c.id} rafraîchie`))
                .catch(ErrorCatcher)
                .finally(() => {
                    refresh()
                })
            }

            $scope.customCaseOrder = function (c) {
                const statusMap = { COURS: '0', ANNUL: '1', TERMN: '2' }
                return statusMap[c.status_code] + (c.milestones[0] ? c.milestones[0].date_time : '')
            }

            refresh()
        },
    })
)
